const config = {
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://startupgeniusai.onrender.com'
};

export default config;